export const api_host = process.env.REACT_APP_API_HOST;

export const saveVenue = (venue, jti) => fetch(api_host + "/?action=VenueSet&jti=" + jti,
    {
        method: "POST",
        body: JSON.stringify(venue)
    }
)
.then(res => (res.status === 200) ? res.json() : false)




